module.exports = __webpack_public_path__ + "static/2ndKitchen-6dc19c33241d8fe08cd69fee1236a247.jpg";